import Vue from 'vue';
import axios from '@galaxy/js/common/AxiosBuilder';

export default Vue.extend({

    props: {
        initialCanvasVersion: Object,
    },

    data()
    {
        return {
            canvasVersion: this.initialCanvasVersion,
            watchCanvasVersionActive: false,
            invalidateTimeout: null,
            skipCanvasVersionWatcher: 0,
            dirty: false,
            saving: false,
            saveToast: null,
        };
    },

    methods: {

        watchCanvasVersion()
        {
            this.watchCanvasVersionActive = true;
        },

        invalidate()
        {
            // Set as dirty.
            this.dirty = true;

            // TODO Use _.debounce?
            // @ugly
            // Wait to manage save, to be able to collect more changes.
            if(this.invalidateTimeout)
                clearTimeout(this.invalidateTimeout);

            this.invalidateTimeout = setTimeout(this.manageSave, 100);
        },

        // TODO Only save block options? And not all other data?
        async manageSave()
        {
            // Abort due to nothing to save or is saving right now?
            if(!this.dirty || this.saving)
                return;

            // Mark as sending.
            this.saving = true;
            this.dirty = false;

            try {
                await this.sendSave();

                //
                await this.manageSave();
            }
            catch(e)
            {
                // Mark back as dirty.
                this.dirty = true;

                // Try again later.
                setTimeout(this.manageSave, 1000);

                //
                throw e;
            }
            finally {
                // Unmark as sending.
                this.saving = false;
            }
        },

        // TODO Only send dirty canvas blocks?
        async sendSave()
        {
            // Send to server.
            const response = await axios.post('/admin/canvas-editor/' + this.canvasVersion.id + '/save', {
                canvasBlocks: this.canvasVersion.canvas_blocks,
            });

            // @ugly Temp disable watcher on this.canvasVersion.
            this.skipCanvasVersionWatcher++;

            // Set latest canvas blocks.
            this.canvasVersion.canvas_blocks = response.data.canvasBlocks;

            // Let Page know.
            this.$emit('newHtml', response.data.html);
        },

        manageSaveToast()
        {
            // Show?
            if (this.saving && !this.saveToast) {
                this.saveToast = this.toasted.show('<i class="fas fa-circle-notch fa-spin"></i> Bezig met opslaan', {
                    duration: 1000000,
                    //type: 'error',
                    iconPack: 'fontawesome',
                    closeOnSwipe: false,
                });
            }
            // Hide?
            else if (!this.saving && this.saveToast) {
                this.saveToast.goAway(0);
                this.saveToast = null;
            }
        },

    },

    watch: {

        'saving'(newVal)
        {
            this.manageSaveToast();

            // @ugly Pass through editor.
            window.canvasEditorIframeComponent.editorComponent.stateSaving = newVal;
        },

        'canvasVersion': {
            deep: true,
            handler(newVal)
            {
                // TODO @ugly Update state outside iframe.
                window.canvasEditorIframeComponent.$parent.$parent.setNewLanguageCanvasVersion(JSON.parse(JSON.stringify(newVal)));

                // Abort due to watch is inactive?
                if(!this.watchCanvasVersionActive)
                    return;

                // @ugly Delegate or ignore?
                if(this.skipCanvasVersionWatcher == 0)
                    this.invalidate();

                else
                    this.skipCanvasVersionWatcher--;
            },
        },

    },

    computed: {

        id2canvasBlock()
        {
            //
            let result = {};

            // Init helper.
            let helper = canvasBlocks =>
            {
                for(let canvasBlock of canvasBlocks)
                {
                    result[canvasBlock.id] = canvasBlock;

                    // Process children? If we added a new block runtime, we might have forgotten to init (empty) childs.
                    if(canvasBlock.children)
                        helper(canvasBlock.children);
                }
            }

            // Execute helper.
            helper(this.canvasVersion.canvas_blocks)

            //
            return result;
        },

        toasted()
        {
            return window.canvasEditorIframeComponent.$toasted;
        },

    },

});
